<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p style="color: white"> {{ 'BASE.LOADING' | translate }} </p>
</ngx-spinner>
<ngx-spinner
  name="uploadSpinner"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p style="color: white"> {{ 'BASE.LOADING' | translate }} </p>
</ngx-spinner>
